import MeshType from './mesh-type.js';
class Mesh {
    mt;
    meshType;
    name = 'mesh';
    numberOfPoints;
    points;
    numberOfPointPixels;
    pointData;
    numberOfCells;
    cells;
    cellBufferSize;
    numberOfCellPixels;
    cellData;
    constructor(mt = new MeshType()) {
        this.mt = mt;
        this.meshType = mt;
        this.name = 'mesh';
        this.numberOfPoints = 0;
        this.points = null;
        this.numberOfPointPixels = 0;
        this.pointData = null;
        this.numberOfCells = 0;
        this.cellBufferSize = 0;
        this.cells = null;
        this.numberOfCellPixels = 0;
        this.cellData = null;
    }
}
export default Mesh;
//# sourceMappingURL=mesh.js.map